import { LockKeyhole } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { GuestSignInLink } from '@components/auth/GuestSignInLink';
import { PageShell, Surface } from '@components/system';

export function GuestAccessPage() {
  const location = useLocation();

  return (
    <PageShell
      eyebrow="SEALED DISTRICT"
      title="这一区域需要正式身份"
      description="游客通行证仅覆盖公开卷宗。登录后才能创建角色、进入房间或使用个人功能。"
      className="guest-access-page"
    >
      <Surface variant="solid" tone="gold" material="archive" padding="lg" className="guest-access-page__card">
        <span className="guest-access-page__icon" aria-hidden="true"><LockKeyhole size={30} /></span>
        <p className="guest-access-page__path">封存路径：{location.pathname}</p>
        <div className="guest-access-page__actions">
          <Link to="/" className="btn-v2 coc-btn-secondary">返回游客首页</Link>
          <GuestSignInLink className="btn-v2 coc-btn-primary">登录或注册</GuestSignInLink>
        </div>
      </Surface>
    </PageShell>
  );
}
